// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosResponse, AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getOnlineCourseRelated } from '../../apis/course';
import { LoadingType } from '../../types/Common';
import { OnlineCourseCard } from '../../types/Model';
import { getOnlineCourseRelatedActions } from '../actionCreators/getOnlineCourseRelatedActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: getOnlineCourseRelatedActions.success,
  failure: getOnlineCourseRelatedActions.failure
};

type RequestActionTypes = ActionType<
  typeof getOnlineCourseRelatedActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getOnlineCourseRelatedEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getOnlineCourseRelatedActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, loadingType = LoadingType.NEW } = action.payload;
      // send api promise
      return getOnlineCourseRelated(id)
        .then((response: AxiosResponse<OnlineCourseCard[]>) => {
          // handle success case here
          return getOnlineCourseRelatedActions.success({
            onlineCourseRelatedData: response.data,
            id,
            loadingType
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return getOnlineCourseRelatedActions.failure({ error });
        });
    })
  );
};
